export default {

  allRequests: [],
  managerAllRequests: [],
  remainLeaves: [],
  dailyWorks: [],

  insuranceList: [],
  insuranceFee: [],
  insuranceFeeTitle: {},

  suggestionList: [],
  managerSuggestionList: [],
  departments: [],

  expertPollHeaders: [],
  managerPollHeaders: [],
  managerPollsHistory: [],
  userPollHeaders: [],
  pollDetails: [],
  answerPollHeaders: [],
  answerPollDetails: [],
  userAnswerPollHeaders: [],
  userAnswerPollDetails: [],

  userComponentAnswers: [],

  pageTotal: 0,

};
